export const HOME_PAGE_DATA = {
    heading: 'React Js Project Base Setup'
}


export const IMAGE_EXTENSIONS = [
    'png', 'jpg', 'webp', 'svg'
]



export const IMAGE_FEATURES = [
    {
        title: "Compress Images",
        description: "Reduce image file size without losing quality. Perfect for faster website loading, saving storage space, and improving SEO. Supports JPG, PNG, and WebP formats.",
        link: "/image-compression",
        icon: "fas fa-compress"
    },
    {
        title: "Resize Images",
        description: "Resize and scale images effortlessly for websites, social media, and printing. Maintain aspect ratio and quality while adjusting dimensions to fit your needs.",
        link: "/image-resizer",
        icon: "fas fa-expand-arrows-alt"
    },
    {
        title: "Convert Images",
        description: "Easily convert image formats (JPG, PNG, WebP) with just one click. Ideal for compatibility across platforms and optimizing images for specific use cases.",
        link: "/image-conversion",
        icon: "fas fa-exchange-alt"
    },
    {
        title: "Optimize Images",
        description: "Make images load faster on websites without sacrificing quality. Reduce file size and improve performance for better user experience and SEO rankings.",
        link: "/image-optimization",
        icon: "fas fa-magic"
    },
    {
        title: "Base64 Conversion",
        description: "Convert images to Base64 format for easy embedding in web applications, emails, and CSS. Simplify your workflow with this powerful encoding tool.",
        link: "/image-base64-converter",
        icon: "fas fa-code"
    },
    {
        title: "Crop Images",
        description: "Crop images to the perfect size for social media, websites, and more. Remove unwanted areas and focus on the most important parts of your image.",
        link: "/crop-image",
        icon: "fas fa-crop"
    },
    {
        title: "Rotate Images",
        description: "Adjust image orientation with ease. Rotate images 90°, 180°, or 270° to correct alignment or create unique visual effects.",
        link: "/rotate-image",
        icon: "fas fa-sync-alt"
    }
];

export const PDF_FEATURES = [
    {
        title: "Merge PDFs",
        description: "Combine multiple PDF files into one document. Perfect for consolidating reports, presentations, or any PDF documents that belong together.",
        link: "/pdf/merge-pdf",
        icon: "fas fa-object-group"
    },
    {
        title: "Split PDF",
        description: "Extract specific pages or split a PDF into multiple documents. Great for separating chapters, forms, or sharing just the needed pages.",
        link: "/pdf/split-pdf",
        icon: "fas fa-cut"
    },
    {
        title: "Images to PDF",
        description: "Combine multiple images into a single PDF document. Create photo albums, portfolios, or convert scanned images to PDF format.",
        link: "/pdf/image-to-pdf",
        icon: "fas fa-file-pdf"
    },
    // {
    //     title: "Extract PDF Text",
    //     description: "Extract text content from PDF files for editing or analysis. Useful for copying text from scanned documents or PDF forms.",
    //     link: "/pdf-text-extract",
    //     icon: "fas fa-font"
    // },
    {
        title: "Rotate PDF Pages",
        description: "Adjust page orientation in PDF documents. Rotate individual pages or entire documents by 90°, 180°, or 270° as needed.",
        link: "/pdf/rotate-pdf",
        icon: "fas fa-redo"
    },
    {
        title: "Reorder PDF Pages",
        description: "Rearrange pages within a PDF document. Change the order of pages to create the perfect document flow.",
        link: "/pdf/reorder-pdf",
        icon: "fas fa-sort-numeric-down"
    },
    {
        title: "Watermark PDF",
        description: "Add text or image watermarks to PDF documents. Brand your documents or mark them as drafts, confidential, etc.",
        link: "/pdf/watermark-pdf",
        icon: "fas fa-stamp"
    },
    {
        title: "Edit PDF Metadata",
        description: "View and modify PDF document properties like title, author, and keywords. Improve organization and searchability of your PDF files.",
        link: "/pdf/edit-meta-data-pdf",
        icon: "fas fa-tags"
    }
];


// export const PDF_FEATURES = [
//     {
//         title: "Merge PDFs",
//         description: "Combine multiple PDF files into one document. Perfect for consolidating reports, presentations, or any PDF documents that belong together.",
//         link: "/pdf-merge",
//         icon: "fas fa-object-group"
//     },
//     {
//         title: "Split PDF",
//         description: "Extract specific pages or split a PDF into multiple documents. Great for separating chapters, forms, or sharing just the needed pages.",
//         link: "/pdf-split",
//         icon: "fas fa-cut"
//     },
//     {
//         title: "Compress PDF",
//         description: "Reduce PDF file size without significant quality loss. Optimize PDFs for email attachments, web uploads, or storage savings.",
//         link: "/pdf-compress",
//         icon: "fas fa-file-export"
//     },
//     {
//         title: "PDF to Images",
//         description: "Convert PDF pages to high-quality images (JPG, PNG, WebP). Useful for sharing PDF content as images on social media or websites.",
//         link: "/pdf-to-image",
//         icon: "fas fa-file-image"
//     },
//     {
//         title: "Images to PDF",
//         description: "Combine multiple images into a single PDF document. Create photo albums, portfolios, or convert scanned images to PDF format.",
//         link: "/image-to-pdf",
//         icon: "fas fa-file-pdf"
//     },
//     {
//         title: "Protect PDF",
//         description: "Add password protection to your PDF files. Secure sensitive documents with encryption to control who can view or edit them.",
//         link: "/pdf-protect",
//         icon: "fas fa-lock"
//     },
//     {
//         title: "Unlock PDF",
//         description: "Remove password protection from PDFs (with proper authorization). Regain access to your own documents when you've forgotten the password.",
//         link: "/pdf-unlock",
//         icon: "fas fa-unlock"
//     },
//     {
//         title: "Edit PDF Metadata",
//         description: "View and modify PDF document properties like title, author, and keywords. Improve organization and searchability of your PDF files.",
//         link: "/pdf-metadata",
//         icon: "fas fa-tags"
//     },
//     {
//         title: "Extract PDF Text",
//         description: "Extract text content from PDF files for editing or analysis. Useful for copying text from scanned documents or PDF forms.",
//         link: "/pdf-text-extract",
//         icon: "fas fa-font"
//     },
//     {
//         title: "Rotate PDF Pages",
//         description: "Adjust page orientation in PDF documents. Rotate individual pages or entire documents by 90°, 180°, or 270° as needed.",
//         link: "/pdf-rotate",
//         icon: "fas fa-redo"
//     },
//     {
//         title: "Reorder PDF Pages",
//         description: "Rearrange pages within a PDF document. Change the order of pages to create the perfect document flow.",
//         link: "/pdf-reorder",
//         icon: "fas fa-sort-numeric-down"
//     },
//     {
//         title: "Watermark PDF",
//         description: "Add text or image watermarks to PDF documents. Brand your documents or mark them as drafts, confidential, etc.",
//         link: "/pdf-watermark",
//         icon: "fas fa-stamp"
//     }
// ];

export const FAQs =  [
    {
        question: "How does image compression work?",
        answer: "Our tool reduces file size by optimizing image data without significantly affecting quality.",
    },
    {
        question: "Is this tool free to use?",
        answer: "Yes! All our tools are completely free with no sign-up required.",
    },
    {
        question: "What formats do you support for images?",
        answer: "We support JPG, PNG, and WebP formats for conversion and optimization.",
    },
    {
        question: "What PDF operations can I perform?",
        answer: "You can merge multiple PDFs, split PDFs into separate pages, compress PDFs, and convert PDFs to images.",
    },
    {
        question: "Is my data secure when using your tools?",
        answer: "Absolutely! All processing happens in your browser - we never upload your files to our servers.",
    },
];



export const HOW_TO_USE_DATA = [
    {
        category: "Image Tools",
        icon: "fas fa-image",
        tools: [
            {
                title: "Compress Images",
                icon: "fas fa-compress",
                steps: [
                    "Upload your image file",
                    "Adjust compression settings",
                    "Download optimized file"
                ]
            },
            {
                title: "Convert Image Formats",
                icon: "fas fa-file-import",
                steps: [
                    "Select your image",
                    "Choose output format (PNG, JPG, WebP, etc.)",
                    "Download converted file"
                ]
            }
        ]
    },
    {
        category: "PDF Tools",
        icon: "fas fa-file-pdf",
        tools: [
            {
                title: "Images to PDF",
                icon: "fas fa-file-merge",
                steps: [
                    "Upload multiple images files",
                    "Arrange pages in the desired order",
                    "Download the merged document"
                ]
            },
            {
                title: "Split PDF",
                icon: "fas fa-cut",
                steps: [
                    "Upload your PDF",
                    "Choose how to split (range, even/odd, equal parts)",
                    "Download separated PDF files"
                ]
            }
        ]
    }
];
